import React from 'react';
import get from 'lodash/get';
import useConfig from 'UI/customHooks/useConfig';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  absoluteImage: {
    position: 'absolute',
    left: 0,
    top: 0,
    opacity: 0,
    transition: '0.25s',
  },
});

const CompanySpecificLogo = ({
  skill,
  style,
  styleAbsolute,
  height = 25,
  shouldLogoChangeOnHover,
  replaceDefaultLogo,
  ...otherProps
}) => {
  const pegasusConfig = useConfig();

  const { cdnUrl } = pegasusConfig;
  const { skillsLogo } = window.PALYX_WHITE_LABEL;

  const classes = useStyles();
  const isCompanySpecificSkillsEnabled = get(
    pegasusConfig,
    `cms.features.skills.companySpecific.isEnabled`,
    false
  );

  const handleLogo = logo => {
    if (logo.startsWith('http')) {
      return logo;
    }
    return `${cdnUrl}${skillsLogo}`;
  };

  const alternativeSkillsLogo = get(
    pegasusConfig,
    'cms.pages.skills.buttonOptions.alternativeSkillsLogo',
    handleLogo(skillsLogo)
  );

  if (isCompanySpecificSkillsEnabled) {
    return (
      <Box sx={{ display: 'flex', position: 'relative' }} data-test="company-specific-logo">
        {shouldLogoChangeOnHover && (
          <img
            alt=""
            className={classes.absoluteImage}
            style={{ height: height, ...style }}
            src={alternativeSkillsLogo}
          />
        )}
        <img
          alt=""
          src={replaceDefaultLogo ? alternativeSkillsLogo : handleLogo(skillsLogo)}
          height={`${height}px`}
          width="auto"
          style={{ marginRight: 5, ...style }} // default styling and custom
          {...otherProps}
        />
      </Box>
    );
  }
  return null;
};

export default CompanySpecificLogo;
